import { gql } from "@apollo/client";

export const senderProviderFieldsFragment = gql`
  fragment SenderProviderFields on Provider {
    ...ProviderFields
  }
`;
